import { z } from "zod";
import {
  EContractorPaymentStatus,
  EContractorPaymentType,
} from "../contractor-payments";
import { schemes } from "../schema-validation";
import { ETxnSpeed } from "../transaction-speeds";
import { EDisbursementMethod } from "../workers-shared";
import { publicPaginationSchema, publicSortSchema } from "../pagination";

const getMyContractorPaymentsQuerySchema = z.object({
  mode: z.enum(["test", "live"]),
  currentYear: z.string().optional(),
  status: z.array(z.nativeEnum(EContractorPaymentStatus)).optional(),
  q: z.string().optional(),
  ...publicPaginationSchema.shape,
  ...publicSortSchema.shape,
  type: z.nativeEnum(EContractorPaymentType).optional(),
  disbursement: z.nativeEnum(EDisbursementMethod).optional(),
  date: z.string().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  amount: z.string().optional(),
  amountFrom: z.string().optional(),
  amountTo: z.string().optional(),
});

export type TGetMyContractorPaymentsQuery = z.infer<
  typeof getMyContractorPaymentsQuerySchema
>;

const getMyContractorPaymentsResponseData = z.object({
  amount: z.number(),
  approval_required: z.boolean(),
  approved: z.boolean(),
  companyID: schemes.companyID(),
  contractorID: schemes.mongoObjectId(),
  disbursement: z
    .object({
      method: z.enum([
        EDisbursementMethod.DIRECT_DEPOSIT,
        EDisbursementMethod.PHYSICAL_CHECK,
        EDisbursementMethod.PREPAID,
      ] as const),
    })
    .optional(),
  createdAt: z.date(),
  first_name: z.string(),
  last_name: z.string(),
  status: z.nativeEnum(EContractorPaymentStatus),
  pay_date: schemes.isoDate(),
  speed: z.nativeEnum(ETxnSpeed),
  type: z.nativeEnum(EContractorPaymentType),
});

export type TGetMyContractorPaymentsResponseData = Array<
  z.infer<typeof getMyContractorPaymentsResponseData>
>;
